// Stajyer gün beyanı durumları. Etiket ve renk tek yerde tutuluyor —
// stajyer ekranı, yönetici onay ekranı ve mobil aynı sözlüğü kullanmalı ki
// aynı durum üç yerde farklı görünmesin.
export const WORK_DAY_STATUS_TAG = {
  pending:  { label: 'Onay Bekliyor', color: 'orange' },
  approved: { label: 'Onaylandı',     color: 'green' },
  rejected: { label: 'Reddedildi',    color: 'red' },
};

export const WORK_DAY_STATUS_OPTIONS = [
  { value: 'pending',  label: 'Onay Bekliyor' },
  { value: 'approved', label: 'Onaylandı' },
  { value: 'rejected', label: 'Reddedildi' },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: 'cash',     label: 'Nakit' },
  { value: 'transfer', label: 'Havale/EFT' },
];
